export default import.meta.ROLLUP_FILE_URL_Gzy6jwXh0xT8XZjZWAlKsA